export enum BorderWidthToken {
  none = 'none',
  nano = '0.1rem',
  micro = '0.2rem',
  small = '0.3rem',
  medium = '0.4rem',
  large = '0.6rem',
}
export default BorderWidthToken

export type TWidth = 'none' | 'nano' | 'micro' | 'small' | 'medium' | 'large'
